export const MANUAL_SEEDING_ROUTE = '/seedlist/manual';

export const AUTOMATIC_SEEDING_ROUTE = '/seedlist/automatic';

export const SEEDING_ACTIVITY_ROUTE = '/seedlist/automatic/activity';
